import React from 'react'
import HomeContact from '../components/HomeSections/HomeContact'

const Contact = () => {
  return (
    <div className='pt-5 mt-4'>
      <HomeContact />
    </div>
  )
}

export default Contact
